import Color from "color";

import { isDark } from "../../theme/utils";

/**
 * Foreground colours matching the old AppStyling Semantic overrides:
 * most colours use a darkened shade of the fill; primary/secondary/etc.
 * use black/white (or the raw colour on light backgrounds).
 *
 * `onPrimary` / `onSecondary` are built separately as mono palettes — do not
 * pass those keys here.
 */
export function textColorsFor(bg: string, colorKey?: string) {
  const colorInstance = Color(bg);
  let textOnWhite = colorInstance.darken(0.5);
  let textOnSolid = colorInstance.darken(0.5);

  if (
    colorKey === "primary" ||
    colorKey === "secondary" ||
    colorKey === "msteams" ||
    colorKey === "black"
  ) {
    textOnWhite = Color(bg);
    textOnSolid = isDark(colorInstance) ? Color("#ffffff") : Color("#000000");
  }

  return {
    colorInstance,
    textOnWhite: textOnWhite.string(),
    textOnSolid: textOnSolid.string(),
  };
}
